import React, { Component } from 'react'
import Header from './Header'

class ErrorNotFound extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div>
                    <h1>ErrorNotFound</h1>
                </div>
            </div>
        )
    }
}

export default ErrorNotFound